<app-spinner [loading]="loading$ | async" size="full"></app-spinner>
<app-spinner [loading]="loadingRules$ | async" size="full"></app-spinner>

<div class="app-breadcrumb">
  <app-header [actionActive]="actionActive$ | async"></app-header>
  <app-breadcumb
    [breadcrumbs]="breadcrumbs$ | async"
    [exceptionMode]="exceptionMode$ | async"
    [connectionTimeDifference]="
      (pnrInfo$ | async) && !(pnrInfo$ | async).itinerary.connectionTime.isValid
    "
    [showExceptionSwitch]="showExceptionSwitch$ | async"
    (toogleExceptionMode)="changeValue($event)"
    [actionActive]="actionActive$ | async"
    [loadingActions]="loadingActions$ | async"
    [pnrInfo]="pnrInfo$ | async"
  ></app-breadcumb>
  <main>
    <router-outlet></router-outlet>
  </main>
</div>
